import Box from "../components/Box/Box";
import useFocusOnLoad from "../hooks/useFocusOnLoad";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useUnregisterFlow } from "../hooks/useUnregisterFlow";

export default function UnregisterTravelError() {
    const h2Ref = useFocusOnLoad<HTMLHeadingElement>();
    const { unregisterData } = useUnregisterFlow();
    const navigate = useNavigate();

    useEffect(() => {
        if (!unregisterData) {
          navigate("/avboka-resa");
          return;
        }
      
        const { ReferenceId, EditId } = unregisterData;
      
        if (!ReferenceId || !EditId ) {
          navigate("/avboka-resa-fel");
        }
      }, [unregisterData, navigate]);

    return (
        <div>
            <Box>
                <h2 ref={h2Ref}>Något gick fel!</h2>
                <p>
                    Vi kunde tyvärr inte avanmäla gruppresan med referensnummer <br />
                    <span className="sans-bold">({unregisterData?.ReferenceId})</span>{" "}
                    just nu på grund av ett fel på vår sida. Vi ber er att prova senare alternativt ringa till oss på telefonnummer <br />
                    <a href="tel:+467715554444" className="text-red-darker">0771 - 555 44 44</a> så hjälper vi er att avanmäla.
                </p>
            </Box>
        </div>
    );
}